import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import 'react-widgets/dist/css/react-widgets.css';
import Loader from 'react-loader-spinner';
import GetDomains from '../GetDomains';


class NamedEntity extends Component {
  constructor() {
    super();

    this.dialogClose = () => {
      this.setState({
        hideupdateDialog: false, hideAddDialog: false, hideErrorAddingDialog: false,
        hideDeletePopup: false, hideMultipleDeletePopup: false,
        hideDeleteAllPopup: false, hideIncorrectPassword: false
      });
    };
    this.DeletedialogClose = () => {
      this.setState({ hideTextAreaPopup: false });
    };
    this.IncorrectPassworddialogClose = () => {
      this.setState({ hideIncorrectPassword: false });
    };

    this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

    //for update dialog component ok click
    this.Okbutton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchNamedEntityDataApi()
        this.dialogClose();

      }
    }];
    this.addedButton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchNamedEntityDataApi()
        this.dialogClose();
        this.setState({

          disabled: false
        })
      }
    }];


    //for delete dialog component ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.deleteNamedEntityApi(props, this.state.propsId)
        this.setState({

          disabled: false, showTable: true
        })

      }
    }
      , {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideDeletePopup: false,

          disabled: false,
          showTable: true
        });
      }
    }];

    //for delete success
    this.deleteSuccessbuttons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.dialogInstance.hide();
        this.fetchNamedEntityDataApi()
        this.setState({ disabled: false, showTable: true })

      }
    }];

    this.multipleDeleteButton = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.deleteMultipleNamedEntityApi()
      }
    }, {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideMultipleDeletePopup: false,
        });
      }
    }];
    //deleteall
    this.deleteAllButton = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      }, 'click': () => {
        this.setState({
          hideDeleteAllPopup: false,
          hideTextAreaPopup: true
        });
      }
    }, {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideDeleteAllPopup: false,
        });
      }
    }];


    //deleteall
    this.textAreaConfir = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': () => {
        this.deleteInputValidation()
      }
    }, {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideTextAreaPopup: false,
        });
      }
    }];
    //incorrectPasswordButtons
    this.incorrectPasswordButtons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': () => {
        this.setState({
          hideTextAreaPopup: true,
          hideIncorrectPassword: false

        })
      }
    }];
    this.state = {
      textChange: false,
      actiavteDisable: false,
      pageNum: null,
      showTable: false,
      deactivateDisable: true,
      hideDeleteAllPopup: false,
      hideIncorrectPassword: false,
      hideTextAreaPopup: false,
      data: [
        {
          id: '',
          namedEntity: '',
          neSubType: '',
          gender: '',
          text: '',
          language: [],
          deleteRow: false,
          customType: ''
        }
      ],
      domain: [],
      domainId: null,
      nameList: [],
      disabled: false,
      editedId: '-1',
      editImageSrc: './assets/images/edit.svg',
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,

      hideErrorAddingDialog: false,

      successResp: false,
      propertyChange: false,
      subTypepropertyChange: false,
      genderpropertyChange: false,
      selectedProperty: [],
      selectedRows: [],
      checkBoxRows: [],
      disableMultipleDelete: true,
      hideMultipleDeletePopup: false
    }
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.activatechangedId = "-2";
    this.deActivatechangedId = "-2";
    this.activateFb = "off";
    this.namedEntityVar = [];
    this.subTypeVar = [];
    this.genderVar = [];
    this.addedData = [];
    this.disableOption = false;
    this.language = "";
    this.domain = "";
    this.customTypeList = [];
    this.searchDataMap = [];

  }
  componentDidMount() {
    setTimeout(() => {
      this.fetchLanguageApi();
      this.fetchDomainApi();
      this.fetchNamedEntityApi();
      this.fetchCustomEntityTypeApi();
      this.fetchSubTypeApi();
      this.fetchGenderApi();
      this.getCustomEntityType();
      this.fetchNamedEntityDataApi();
    }, 300);

    var thisController = this;
    document.addEventListener("projectChanged", function (event) {
      if (document.getElementById("languageIdDropDown") != null &&
        document.getElementById("domainDropDown") != null) {
        thisController.projectId = event.projectId;
        thisController.fetchLanguageApi(event.projectId);
        thisController.fetchDomainApi();
        thisController.fetchNamedEntityDataApi();
        thisController.fetchNamedEntityApi();
        thisController.fetchSubTypeApi();
        thisController.fetchGenderApi();
        thisController.getCustomEntityType(event.projectId);
        thisController.fetchCustomEntityTypeApi(event.projectId);

      }
    });
  }
  fetchDomainApi = () => {
    var domain = GetDomains();
    this.setState({ domain: domain });
    var domainOptionTag = document.getElementById("domainDropDown");
    if (domainOptionTag != "") {
      if (domainOptionTag != null) {
        domainOptionTag.innerHTML = "";

        if (domainOptionTag != null) {
          for (var i = 0; i < domain.length; i++) {
            domainOptionTag.innerHTML = domainOptionTag.innerHTML + '<option value="' +
              domain[i]["domainId"] + '">' + domain[i]["domain"] + '</option>';
          }
          this.setState({ domainId: document.getElementById('domainDropDown') })
          this.setState(this.state);
        }
      }
    }

  }
  saveNamedEntityApi = (props, e) => {
    var addController = this;

    props.original.text =
      document.getElementById("text" + props.index).innerText.trim();

    props.original.namedEntity =
      document.getElementById("namedEntity" + props.index).value;

    props.original.neSubType =
      document.getElementById("neSubType" + props.index).value;

    props.original.gender =
      document.getElementById("gender" + props.index).value;

    props.original.language = document.getElementById('languageIdDropDown').value;

    props.original.domain = document.getElementById('domainDropDown').value;
    var customType = document.getElementById('customType' + props.index).value;
    if (customType == "None") {
      customType = "";
    }


    addController.state.editedId = "-1";
    addController.setState(this.state);

    var validateResult = addController.validateCells(
      props.original.text,
      props.original.namedEntity,
      props.original.neSubType,
      props.original.gender,
      props.original.language,
      props.original.domain);


    if (validateResult == true) {
      var addedData = {
        text: props.original.text,
        namedEntity: props.original.namedEntity,
        neSubType: props.original.neSubType,
        gender: props.original.gender,
        language: props.original.language,
        domainId: props.original.domain,
        projectId: localStorage.getItem('currentProjectId'),
        customType: customType

      };


      $.ajax({
        url: "/api/ner",
        async: false,
        method: 'POST',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(addedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {


            addController.notifyAdd();
            addController.fetchNamedEntityDataApi();
            addController.state.disabled = false;


          } else if (res.success === false) {
            addController.notifyError(res.result);
          }
        },
      })

    }

  }
  notifyAdd() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;
      Language Specific Entity Added Successfully</b>, {
      position: "top-center",

    });
  }
  notifyError(response) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      {response}</b>, {
      position: "top-center"
    });
  }


  updateNamedEntityApi(props, e) {
    var updateController = this;

    props.original.text = document.getElementById("text" + props.index).innerText.trim();
    props.original.namedEntity = document.getElementById("namedEntity" + props.index).value;
    props.original.neSubType =
      document.getElementById("neSubType" + props.index).value;

    props.original.gender =
      document.getElementById("gender" + props.index).value;

    props.original.language = document.getElementById('languageIdDropDown').value;

    props.original.domain = document.getElementById('domainDropDown').value;

    var customType = document.getElementById('customType' + props.index).value;
    if (customType == "None") {
      customType = "";
    }
    var validateResult = updateController.validateCells(
      props.original.text,
      props.original.namedEntity,
      props.original.neSubType,
      props.original.gender,
      props.original.language,
      props.original.domain);
    if (validateResult == true) {
      var updatedData = {
        text: props.original.text,
        namedEntity: props.original.namedEntity,
        neSubType: props.original.neSubType,
        gender: props.original.gender,
        language: props.original.language,
        domainId: props.original.domain,
        projectId: localStorage.getItem('currentProjectId'),
        id: props.original.id,
        customType: customType

      };
      var updatedDataController = this
      $.ajax({
        url: "/api/ner",
        async: false,
        method: 'PATCH',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(updatedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            updatedDataController.state.editedId = "-1";
            updatedDataController.notifyUpdate();
            updatedDataController.fetchNamedEntityDataApi();
          } else if (res.success == false) {
            updatedDataController.notifyError(res.result);
          }
        },

      })
    }
  }
  notifyUpdate() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
      content="" />&nbsp;&nbsp;Language Specific Entity Updated Successfully</b>, {
      position: "top-center",

    });
  }

  deleteNamedEntityApi = (props, id) => {
    let deleteRowViewController = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;



    $.ajax({
      url: "/api/ner/" + id,
      async: false,
      method: 'DELETE',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {

        if (res.success === true) {

          deleteApiViewController.setState({ deleteRow: true });
          deleteConstructorVariables.setState({ hideDeletePopup: false });
          deleteApiViewController.notifyDelete();
          deleteRowViewController.splice(id, 1);



        } else {
          deleteApiViewController.notifyError(res.result);
        }
      },
    });
    deleteApiViewController.fetchNamedEntityDataApi();

  }
  notifyDelete() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
      content="" />&nbsp;&nbsp;Language Specific Entity Deleted Successfully</b>, {
      position: "top-center",

    });

  }

  deleteMultipleNamedEntityApi = () => {
    let deleteApiViewController = this;
    var idListVal = deleteApiViewController.state.selectedRows;
    var idList = [];
    for (var i = 0; i < idListVal.length; i++) {
      idList.push(idListVal[i].id);
    }
    $.ajax({
      url: "/api/ner-delete-multiple/" + idList,
      async: false,
      method: 'DELETE',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },

      success: function (res) {
        if (res.success === true) {
          deleteApiViewController.state.hideMultipleDeletePopup = false;
          deleteApiViewController.state.disableMultipleDelete = true;
          deleteApiViewController.state.checkBoxRows = [];
          deleteApiViewController.setState(deleteApiViewController.state);
          deleteApiViewController.fetchNamedEntityDataApi();
          deleteApiViewController.notifyMultipleDeleteSuccess();
        } else {
          deleteApiViewController.notifyError(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });
  }

  notifyMultipleDeleteSuccess() {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
        content="" />&nbsp;&nbsp;Selected Language Specific Entities Deleted Successfully</b>, {
      position: "top-center",
    });

  }

  validateFetchData() {

    var queryData = document.getElementById('query').value;

    this.searchDataMap = [];
    var customType = document.getElementById('customEntityType').value;
    if (customType == "None") {
      customType = "";
    }
    if ((queryData != "" && queryData != null)) {
      this.searchDataMap.push({
        projectId: localStorage.getItem('currentProjectId'),
        language: document.getElementById('languageIdDropDown').value,
        domainId: document.getElementById('domainDropDown').value,
        searchText: document.getElementById('query').value,
        customType: customType
      })

    }
    else if (document.getElementById('customEntityType').value != "") {
      this.searchDataMap.push({
        projectId: localStorage.getItem('currentProjectId'),
        language: document.getElementById('languageIdDropDown').value,
        domainId: document.getElementById('domainDropDown').value,
        customType: customType
      });
    }
    else {
      this.searchDataMap.push({
        projectId: localStorage.getItem('currentProjectId'),
        language: document.getElementById('languageIdDropDown').value,
        domainId: document.getElementById('domainDropDown').value,
        customType: document.getElementById('customEntityType').value
      });
    }
    return this.searchDataMap[0];
  }
  fetchNamedEntityDataApi = () => {
    var fetchDataContoller = this;
    var updatedData = fetchDataContoller.validateFetchData();
    $.ajax({
      url: "/api/ner/search",
      async: false,
      method: 'GET',
      data: fetchDataContoller.searchDataMap[0],

      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },

      success: function (res) {


        if (res.success === true) {
          fetchDataContoller.state.data = res.result;
          fetchDataContoller.state.disabled = false;
          fetchDataContoller.state.successResp = true
          fetchDataContoller.setState(fetchDataContoller.state);
        }
        else {
          fetchDataContoller.setState({
            successResp: false
          })
          fetchDataContoller.notifyError(res.result);

        }
      },

    });

  }
  fetchLanguageApi(projectId) {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var languageController = this;
    $.ajax(
      {
        url: "/api/project-languages-selected",
        async: false,
        method: 'GET',
        data: {
          projectId: projectId
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token")
        },
        success: function (res) {
          if (res.success === true) {
            var loadedLang = res.result;

            languageController.setState({ language: loadedLang });
            var numberOfLanguages = loadedLang.length;
            var ele3 = document.getElementById("languageIdDropDown");

            if (ele3 != null) {
              if (ele3.value != "") {
                ele3.innerHTML = "";
              }
              for (var i = 0; i < numberOfLanguages; i++) {
                ele3.innerHTML = ele3.innerHTML + '<option value="' + loadedLang[i]
                ['code'] + '">' + loadedLang[i]['name'] + '</option>';
              }

            }
          }
          else {
            languageController.NotifyFailedLoadLang();
          }
        },
      }
    )

  }

  fetchNamedEntityApi = () => {
    var namedEntityController = this;
    $.ajax(
      {
        url: "/api/named-entities",
        async: false,
        method: 'GET',

        headers: { 'Authorization': "Bearer " + localStorage.getItem("access_token") },
        success: function (res) {
          if (res.success === true) {
            var namedEntities = res.result;
            namedEntityController.state.data.namedEntity = namedEntities
            var numberOfnamedEntities = namedEntities.length;
            var ele3 = document.getElementById('namedEntity');
            namedEntityController.namedEntityVar = [];


            for (var i = 0; i < numberOfnamedEntities; i++) {

              namedEntityController.namedEntityVar[i] = (namedEntities[i]['code']);

            }

          }
          else {
            namedEntityController.notifyError(res.result);
          }
        },

      }
    )
  }

  fetchSubTypeApi = () => {
    var subTypeController = this;
    $.ajax(
      {
        url: "/api/ne-sub-types",
        async: false,
        method: 'GET',


        headers: { 'Authorization': "Bearer " + localStorage.getItem("access_token") },
        success: function (res) {
          if (res.success === true) {
            var subTypes = res.result;
            subTypeController.state.data.neSubType = subTypes
            var numberOfsubTypes = subTypes.length;
            var ele3 = document.getElementById('neSubType');
            subTypeController.socialPlatformPropertyVar = [];


            for (var i = 0; i < numberOfsubTypes; i++) {

              subTypeController.subTypeVar[i] = (subTypes[i]['code']);

            }

          }
          else {
            subTypeController.notifyError(res.result);
          }
        },
      }
    )
  }


  fetchGenderApi = () => {
    var genderController = this;
    $.ajax(
      {
        url: "/api/genders",
        async: false,
        method: 'GET',

        headers: { 'Authorization': "Bearer " + localStorage.getItem("access_token") },
        success: function (res) {
          if (res.success === true) {
            var genders = res.result;
            genderController.state.data.gender = genders
            var numberOfgenders = genders.length;
            var ele3 = document.getElementById('gender');
            genderController.genderVar = [];


            for (var i = 0; i < numberOfgenders; i++) {

              genderController.genderVar[i] = (genders[i]['code']);

            }

          }
          else {
            genderController.notifyError(res.result);
          }
        },

      }
    )
  }
  deleteAllApi = () => {
    let deleteApiViewController = this;
    $.ajax({
      url: "/api/ner/delete/all",
      async: false,
      method: 'POST',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      data: {
        projectId: localStorage.getItem('currentProjectId'),
        domainId: document.getElementById('domainDropDown').value,
        language: document.getElementById('languageIdDropDown').value
      },
      success: function (res) {

        if (res.success === true && res.result === "done.") {
          deleteApiViewController.state.hideTextAreaPopup = false;
          deleteApiViewController.state.checkBoxRows = [];
          deleteApiViewController.setState(deleteApiViewController.state);
          deleteApiViewController.fetchNamedEntityDataApi();
          deleteApiViewController.notifyDeleteAllSuccess();
        } else if (res.success === true && res.result != "done.") {
          deleteApiViewController.notifyNodata(res.result);
        } else {
          deleteApiViewController.notifyFailedDelete(res.result);
        }
      },

      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }

    });
  }
  notifyDeleteAllSuccess() {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
        content="" />&nbsp;&nbsp;All Language Specific Entities have been deleted Successfully</b>, {
      position: "top-center",
    });

  }


  notifyFailedDelete(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });


  }

  notifyNodata(response) {

    this.setState({
      hideTextAreaPopup: false
    })
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });


  }

  deleteInputValidation = () => {
    if (document.getElementById('deleteInputFromUser').value == "Delete" ||
      document.getElementById('deleteInputFromUser').value == "delete" ||
      document.getElementById('deleteInputFromUser').value == "DELETE") {
      document.getElementById('deleteInputFromUser').value = "";
      this.deleteAllApi();
    }
    else {
      this.setState({
        hideIncorrectPassword: true
      })
    }
  }

  validateCells(text, namedEntity, neSubType, gender, language, domain) {

    if ((namedEntity == "" || text == "" || neSubType == "" || gender == "" || language == "" || domain == "")) {
      this.notifyMsgFieldEmpty();
      return false;
    }
    else {
      return true;
    }


  }

  validateUpdatedDate(value) {
    if (value == "" || value == null) {
      this.notifyMsgFieldEmpty();
      return false;
    }
    else {
      return true;
    }
  }
  notifyMsgFieldEmpty() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;
      Please fill all the data</b>, {
      position: "top-center"
    });

  }



  addRow = (data) => {
    var rowController = this;
    if (rowController.state.pageNum != 0) {
      rowController.setState({ pageNum: 0 })
    }

    this.state.data.unshift({
      namedEntity: this.state.namedEntity,
      text: '',
      namedEntity: this.namedEntityVar,
      neSubType: this.subTypeVar



    });
    this.setState({
      data: this.state.data,
      disabled: true
    })
  }

  makeCelleditable(props, e) {
    this.markAsBeingEdited(props.original.id);
  }
  markAsBeingEdited(id) {
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }
  refreshData = (id) => {
    var refreshContent = this
    refreshContent = this.state.editedId = id;
    this.state.selectedRows = [];
    this.state.disableMultipleDelete = true;
    this.state.checkBoxRows = []; this.fetchNamedEntityDataApi()
    this.setState({
      disabled: false,
      showTable: true
    })
  }



  textHandleChange(props, event) {
    props.original.text = document.getElementById("text" + props.index).innerText;

    this.setState(this.state);
    this.state.textChange = true;


  }
  notifyEmptyFields() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Please fill all the data</b>, {
      position: "top-center"
    });
  }



  namedentityOptionHandleChange = (props, e) => {
    props.original.namedEntity = e.target.value;
    props.original.text = document.getElementById("text" + props.index).innerText;
    this.setState(this.state);
    this.state.propertyChange = true;
  }
  subTypeOptionHandleChange = (props, e) => {
    props.original.neSubType = e.target.value;
    props.original.text = document.getElementById("text" + props.index).innerText;
    this.setState(this.state);
    this.state.subTypepropertyChange = true;
  }

  genderOptionHandleChange = (props, e) => {
    props.original.gender = e.target.value;
    props.original.text = document.getElementById("text" + props.index).innerText;
    this.setState(this.state);
    this.state.genderpropertyChange = true;
  }
  queryHandleChange = (e) => {
    this.fetchNamedEntityDataApi();
  }
  domainhandleChange = (e) => {

    this.fetchNamedEntityDataApi();

  }
  langhandleChange = (e) => {
    this.fetchNamedEntityDataApi();
  }
  onPageChange = (e) => {
    this.setState({ pageNum: e })
  }
  onChange = (props) => {
    alert('data is ' + document.getElementById("text" + props.index).innerHTML);
  }

  customTypeHandleChange = (props, e) => {
    props.original.text = document.getElementById("text" + props.index).innerText;
    props.original.customType = e.target.value;
    this.setState(this.state);
  }

  fetchCustomEntityTypeApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    let namedEntityController = this;
    $.ajax({
      url: "/api/custom-entity-type",
      type: 'GET',
      async: false,
      headers: {
        "Authorization": "Bearer" + localStorage.getItem("access_token")
      },
      data: { projectId: projectId },
      success: function (res) {
        if (res.success === true) {
          for (var i = 0; i < res.result.length; i++) {
            namedEntityController.
              customTypeList.push(res.result[i])
          }
        }
        else {
          namedEntityController.notifyError(res.result);
        }
      },

      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });
  }

  fetchCustomEntityTypeApi = () => {
    let namedEntityController = this;
    $.ajax({
      url: "/api/custom-entity-type",
      type: 'GET',
      async: false,
      headers: {
        "Authorization": "Bearer" + localStorage.getItem("access_token")
      },
      data: { projectId: localStorage.getItem('currentProjectId') },
      success: function (res) {
        if (res.success === true) {
          for (var i = 0; i < res.result.length; i++) {
            namedEntityController.
              customTypeList.push(res.result[i])
          }
        }
        else {
          namedEntityController.notifyError(res.result);
        }
      },

      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });
  }



  customTypehandleChangeOutside = () => {
    this.fetchNamedEntityDataApi();
  }
  getCustomEntityType = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    let mlcdController = this;
    $.ajax({
      url: "/api/custom-entity-type",
      async: false,
      method: 'GET',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      data: { projectId: projectId },
      success: function (res) {
        if (res.success === true) {
          var responseData = res.result;
          var numberOfSubtypes = responseData.length;
          var ele3 = document.getElementById("customEntityType");
          if (ele3 != "") {
            if (ele3 != null) {
              if (ele3.value != "Select Custom entity type") {
                ele3.innerHTML = "";
              }
              ele3.innerHTML = ele3.innerHTML + '<option value="">' + "None" + '</option>';
              for (var i = 0; i < numberOfSubtypes; i++) {
                ele3.innerHTML = ele3.innerHTML + '<option value="' + responseData[i]['typeName'] +
                  '">' + responseData[i]['typeName'] + '</option>';
              }
            }
          }
        } else {
          mlcdController.notifyError(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });
  }

  selectedRow = (props, e) => {
    this.state.selectedRows = [];
    var jsonData = props.original;
    for (var i = 0; i < this.state.checkBoxRows.length; i++) {
      if (this.state.checkBoxRows[i]["id"] == jsonData.id) {
        this.state.checkBoxRows.splice(i, 1);
      }
    }
    if (e.target.checked) {
      jsonData["selected"] = true;
    } else {
      jsonData["selected"] = false;
    }
    this.state.checkBoxRows.push(jsonData);
    for (var i = 0; i < this.state.checkBoxRows.length; i++) {
      if (this.state.checkBoxRows[i]["selected"] == true) {
        this.state.selectedRows.push(this.state.checkBoxRows[i]);
      }
    }
    if (this.state.selectedRows.length > 0) {
      this.state.disableMultipleDelete = false;
    } else {
      this.state.disableMultipleDelete = true;
    }
    this.setState(this.state);
  }

  render() {
    const { data } = this.state
    const columns = [
      {
        Header: <b>Select</b>,
        accessor: "id",
        sortable: false,
        width: 55,
        Cell: props => (
          <div style={{ textAlign: 'center' }}>
            <input type="checkbox"
              disabled={props.original.id === undefined ? true : false}
              style={{ width: "20px", height: "20px", cursor: "pointer" }}
              onClick={(e) => {
                this.selectedRow(props, e)
              }}
              checked={props.original.selected}
            />
          </div>)
      },
      {
        Header: <b>Text</b>,
        accessor: 'text',
        sortable: false,

        Cell: props =>


        (<div
          Align="left" className="input"
          style={{
            padding: '8px', width: '98%', borderBottom: 'none',
            border: (props.original.id == undefined || props.original.id == this.state.editedId) ?
              '1px solid #D2D4DC' : 'none', borderRadius:
              (props.original.id == undefined) ? '2px' : 'none', paddingLeft: '2px'
          }}
          suppressContentEditableWarning
          contentEditable={!((props.original.id == undefined) ? false :
            props.original.id != this.state.editedId) ? "plaintext-only" : false}

          type="text" id={"text" + props.index} defaultValue={props.original.text}>
          {props.original.text}
        </div>)



      },
      {
        Header: <b>Language Specific Entity</b>,
        textAlign: 'screenLeft',
        accessor: 'namedEntity',
        sortable: false,
        Cell: props => {
          return (
            <div className="container-fluid" style={{ textAlign: "right" }}>
              <select className="input-group form-control select2 " multiple={false}
                onChange={(e) => this.namedentityOptionHandleChange(props, e)}
                value={props.original.namedEntity}
                id={'namedEntity' + props.index}
                style={{ background: 'white', border: 'none' }}
                disabled={(props.original.id == null) ? false : props.original.id != this.state.editedId}>
                {this.namedEntityVar.map(namedEntity => (
                  <option key={namedEntity} value={namedEntity} >
                    {namedEntity}
                  </option>
                ))}
              </select>

            </div>
          )
        },
      },

      {
        Header: <b>Sub-Type</b>,
        textAlign: 'screenLeft',
        accessor: 'neSubType',
        sortable: false,
        Cell: props => {
          return (
            <div className="container-fluid" style={{ textAlign: "right" }}>
              <select type="select-multiple" className="input-group form-control select2 "
                multiple={false} onChange={(e) => this.subTypeOptionHandleChange(props, e)}
                value={props.original.neSubType} id={'neSubType' + props.index}
                style={{ background: 'white', border: 'none' }}
                disabled={(props.original.id == null) ? false : props.original.id != this.state.editedId}>
                {this.subTypeVar.map(neSubType => (
                  <option key={neSubType} value={neSubType} >
                    {neSubType}
                  </option>
                ))}
              </select>

            </div>
          )
        },
      },

      {
        Header: <b>Gender</b>,
        textAlign: 'screenLeft',
        accessor: 'gender',
        sortable: false,
        Cell: props => {
          return (
            <div className="container-fluid" style={{ textAlign: "right" }}>
              <select type="select-multiple" className="input-group form-control select2 "
                multiple={false}
                onChange={(e) => this.genderOptionHandleChange(props, e)}
                value={props.original.gender} id={'gender' + props.index}
                style={{ background: 'white', border: 'none' }}
                disabled={(props.original.id == null) ? false : props.original.id != this.state.editedId}>
                {this.genderVar.map(gender => (
                  <option key={gender} value={gender} >
                    {gender}
                  </option>
                ))}
              </select>

            </div>
          )
        },
      },
      {
        Header: <b>Custom Type</b>,
        accessor: 'customType',
        width: 150,
        sortable: false,
        Cell: props => {
          return (
            <div className="container-fluid"  >
              <select type="select-multiple" className="input-group form-control select2 "
                multiple={false}
                onChange={(e) => this.customTypeHandleChange(props, e)}
                value={props.original.customType}
                id={'customType' + props.index}
                style={{ background: 'white', border: 'none' }}
                disabled={(props.original.id == null) ? false : props.original.id != this.state.editedId}>
                <option key="" value="" >
                  None
                </option>
                {this.customTypeList.map(typeName => (
                  <option key={typeName.typeName} value={typeName.typeName} >
                    {typeName.typeName}
                  </option>
                ))}
              </select>
            </div>
          )
        },
      },
      {
        Header: <b>Action</b>,
        accessor: 'action',
        width: 100,
        sortable: false,
        Cell: props => {
          return (
            <div className="container-fluid" style={{
              textAlign: "center", marginLeft: '-34px',
              display: (props.original.source != "") ? 'block' : 'none'
            }}>
              <button type="button" className="btn btn-primary pull-right navyblue-btn"
                onClick={(e) => {
                  (this.state.data[props.index].id == undefined)
                    ?
                    this.saveNamedEntityApi(props, e)
                    :
                    ((this.state.data[props.index].id == this.state.editedId)
                      ? this.updateNamedEntityApi(props, e) : this.makeCelleditable(props, e));
                }}
                style={{
                  height: '26px', width: '28px',
                  cursor: 'pointer', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                }}
              >
                <img className="img-responsive" title={(props.original.id == undefined) ||
                  (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                  src={(props.original.id == undefined)
                    ?
                    this.saveImageSrc :

                    ((props.original.id
                      != this.state.editedId)
                      ?
                      this.editImageSrc : this.saveImageSrc)}

                />

              </button>
              <button type="button"
                className="btn btn-primary pull-right navyblue-btn"

                onClick={() => {
                  (props.original.id) === undefined ?
                    this.fetchNamedEntityApi() :
                    this.setState({
                      hideDeletePopup: true, propsId: props.original.id
                    })
                }}
                style={{
                  height: '26px', marginRight: '-65px', width: '28px',
                  backgroundColor: '#282a65', borderRadius: '5px', padding: '1px', cursor: "pointer", paddingRight: "0px"
                }}>
                <img src="assets/images/baseline_delete_white_24dp.png"
                  title='Delete'
                  style={{ marginTop: '-6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                />

              </button>
            </div>)
        },
      },
    ]
    return (
      <div>
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={this.state.successResp ? false : true}
          height={400}
          width={50}
          style={{ textAlign: 'center' }}
        />
        <div style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }} className="container-fluid">


          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />

          {/* for reactTable */}
          <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />

          {/*for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <div className="row" style={{ marginTop: '-7px' }}>
            {/* language */}
            <div className="col-sm-4">
              <h6 className="taglineTxt"></h6>
              <label style={{ marginLeft: '9px' }}>Language</label>
              <select id="languageIdDropDown"
                onChange={this.langhandleChange}
                style={{
                  width: '50%', height: '30px', borderRadius: '4px',
                  backgroundColor: '#F9F9FB',
                  marginLeft: '16px'

                }} >

              </select>
            </div>


            {/* Directive types*/}
            <div className="col-sm-4">
              <h6 className="taglineTxt"></h6>
              <label>Domain</label>
              <select id="domainDropDown"
                onChange={this.domainhandleChange}
                style={{
                  height: '30px', borderRadius: '4px', width: '50%',
                  backgroundColor: '#F9F9FB', marginLeft: '18px'
                }}>

              </select>
            </div>
            <div className="col-sm-4">
              <h6 className="taglineTxt"></h6>
              <label>Custom Entity Type</label>
              <select id="customEntityType" value={this.state.value}
                onChange={this.customTypehandleChangeOutside} placeholder="Select custom entity type"
                style={{
                  height: '30px', borderRadius: '4px',
                  backgroundColor: '#F9F9FB', width: '50%', marginLeft: '10px'
                }}>
                <option hidden value='null'>None</option>
              </select>
            </div>
          </div>
          <div className="row" id="mlcd" style={{ marginLeft: '10px' }}  >
            <div className="col-sm-4" Align='left' >

              <h6 className="nav-item" style={{ color: '#282a65', marginTop: '24px' }}>
                Language Specific Entities</h6>
            </div>
            <div className="col-sm-8" Align='right'>
              <div className="input-group search-btn" style={{
                marginTop: '-28px', width: '200px', display: 'inline-block',
                backgroundColor: 'rgb(249, 249, 251)', marginRight: '150px'
              }} >

                <div className="search-icon" >

                  <input className="border-none" type="search" placeholder="Search"
                    onKeyPress={this.onKeyPressHandleChange}
                    aria-label="Search"
                    style={{
                      width: '77%', height: '80%',
                      filterable: true, backgroundColor: 'rgb(249, 249, 251)',
                      font: 'bold', color: 'black'
                    }} id="query" />
                  <button onClick={this.queryHandleChange} style={{
                    border: 'none',
                    backgroundColor: '#F9F9FB'
                  }}>
                    <img src="assets/images/search.svg"
                      style={{ width: '18px', cursor: 'pointer' }} /></button>
                </div>
              </div>
              {/* <button className="btn action-button"
                style={{ marginTop: '5px' }}
                id="addMsg" title=" Delete All "
                onClick={() => {
                  this.setState({
                    hideDeleteAllPopup: true
                  })
                }}>
                Delete All
              </button> */}
              <button className="btn action-button "
                disabled={this.state.disableMultipleDelete}

                title="Delete Selected"
                id="deleteMultiple"
                onClick={() => {
                  this.setState({
                    hideMultipleDeletePopup: true
                  })
                }
                }>
                <img src={"./assets/images/baseline_delete_white_24dp.png"} />
              </button>
              <button className="btn action-button " Align='right'
                id="addMsg"
                onClick={this.state.disabled ? this.notifyEmptyFields : this.addRow}
                title="Add">
                <img src="assets/images/add_white_24dp.png" />
              </button>
              <button onClick={this.refreshData} className="btn action-button">
                <img src="./assets/images/refresh_white_24dp.png" title="Refresh"></img>
              </button>
            </div>
          </div>

          <div className="content" >
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12" style={{ marginLeft: '9px' }}>
                  <div className="card">
                    <ReactTable
                      getTrProps={(state, rowInfo) => {
                        if (rowInfo) {
                          return {
                            style: {
                              background: this.state.selectedRows.some((selectedRow) => selectedRow.id == rowInfo.original.id) ? '#E6E6D8' : 'white'
                            }
                          }
                        } else {
                          return {}
                        }
                      }
                      }
                      data={data}
                      columns={columns}
                      defaultPageSize={10}
                      pageSizeOptions={[5, 10, 15]}
                      onPageChange={this.onPageChange}
                      page={this.state.pageNum}

                    />
                  </div>
                </div>

                <ToastContainer className="Toast-at-center" />




                {/*Dialog Component For Deletion Confirmation*/}
                <DialogComponent width='400px' animationSettings={this.settings}
                  header='Language Specific Entity' showCloseIcon={true} buttons={this.buttons}
                  ref={dialog => this.dialogInstance = dialog}
                  visible={this.state.hideDeletePopup} close={this.dialogClose}>
                  <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                    content="" />&nbsp;Do you want to delete the Language Specific Entity?<br />Note: Press 'Yes' to delete or press 'No' to decline.
                </DialogComponent>

                {/*Dialog Component For Multiple Deletion Confirmation*/}
                <DialogComponent width='400px' animationSettings={this.settings}
                  header='Language Specific Entity' showCloseIcon={true} buttons={this.multipleDeleteButton}
                  ref={dialog => this.dialogInstance = dialog}
                  visible={this.state.hideMultipleDeletePopup} close={this.dialogClose}>
                  <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                    content="" />&nbsp;Do you want to delete the selected language specific entities?<br />Note: Press 'Yes' to delete or press 'No' to decline.
                </DialogComponent>
                {/*Dialog Component For  Deletion all Confirmation*/}
                <DialogComponent width='400px' animationSettings={this.settings}
                  header='Delete All' showCloseIcon={true} buttons={this.deleteAllButton}
                  ref={dialog => this.dialogInstance = dialog}
                  visible={this.state.hideDeleteAllPopup} close={this.dialogClose}>
                  <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                    content="" />&nbsp;Do you want to delete all the Language Specific Entities?<br />Note: Press 'Yes' to delete or press 'No' to decline.
                </DialogComponent>



                <DialogComponent width='400px' animationSettings={this.settings}
                  header='Incorrect Password' showCloseIcon={true} buttons={this.incorrectPasswordButtons}
                  ref={dialog => this.dialogInstance = dialog}
                  visible={this.state.hideIncorrectPassword} close={this.IncorrectPassworddialogClose}>
                  Please type "Delete"
                </DialogComponent>


                <DialogComponent width='400px' animationSettings={this.settings}
                  header='Delete Confirmation' showCloseIcon={true} buttons={this.textAreaConfir}
                  ref={dialog => this.dialogInstance = dialog}
                  visible={this.state.hideTextAreaPopup} close={this.DeletedialogClose}>
                  Please type "Delete" for confirmation<input type="text" id="deleteInputFromUser" />
                </DialogComponent>
              </div>
            </div>
          </div>
        </div>
      </div>
    )

  }
}

export default NamedEntity;


// WEBPACK FOOTER //
// ./src/projectmgmt/MultiLingualData/NamedEntity.js